import * as React from 'react'
import { AutocompleteArrayInput, Edit, SimpleForm, TextInput, email } from 'react-admin'

import { ComponentWithDynamicResourceHeader } from 'dash/shared/molecules/ComponentWithSubheader'
import { PageTitle, SaveOnlyToolbar } from 'shared/react-admin'

export const UserEdit = () => {
  const validateName = [
    (value) => (value.trim().split(' ').length <= 1 ? 'must be at least 2 words (First Last)' : undefined),
  ]

  return (
    <Edit redirect={false} title={<PageTitle resource="User" source="name" />}>
      <ComponentWithDynamicResourceHeader recordAttrForBreadrumb="name">
        <SimpleForm redirect={false} toolbar={<SaveOnlyToolbar />}>
          {/* <TextInput disabled label="Id" source="id" /> */}
          <TextInput source="name" validate={validateName} />
          <TextInput source="email" validate={email()} />
          <TextInput source="phone" />
          <TextInput source="homepage" />
          <AutocompleteArrayInput
            source="stacks"
            choices={[
              { id: 'cloudflare', name: 'Cloudflare' },
              { id: 'gatsby', name: 'Gatsby' },
              { id: 'go', name: 'Go' },
              { id: 'heroku', name: 'Heroku' },
              { id: 'hugo', name: 'Hugo CMS' },
              { id: 'javascript', name: 'Javascript' },
              { id: 'jekyll', name: 'Jekyll' },
              { id: 'netlify', name: 'Netlify' },
              { id: 'react_native', name: 'React Native' },
              { id: 'react', name: 'React' },
              { id: 'swift', name: 'Swift' },
              { id: 'typescript', name: 'Typescript' },
              { id: 'vue', name: 'Vue' },
              { id: 'ruby', name: 'Ruby' },
              { id: 'python', name: 'Python' },
              { id: 'clojure', name: 'Clojure' },
              { id: 'java', name: 'Java' },
              { id: 'SQL', name: 'SQL' },
              { id: 'nosql', name: 'NoSQL' },
              { id: 'mariadb', name: 'MariaDB' },
              { id: 'postgres', name: 'Postgres' },
              { id: 'kubernetes', name: 'Kubernetes' },
              { id: 'docker', name: 'docker' },
              { id: 'wordpress', name: 'Wordpress' },
              { id: 'shopify', name: 'Shopify' },
            ]}
          />
          <h3>Identities</h3>
          <TextInput source="github" />
          <TextInput source="slack" />
          <TextInput source="google" />
          <TextInput source="apple" />
        </SimpleForm>
      </ComponentWithDynamicResourceHeader>
    </Edit>
  )
}
